import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

// Components
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import DataTable from 'components/CncUI/DataTable';
import EmptyMyFiles from './EmptyMyFiles';
import FileDownloader from 'components/FileDownloader';
import FileViewer from 'components/FileViewer';

// Icons
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import DownloadIcon from '@material-ui/icons/GetApp';

// Hooks
import useBrowserMatchVersion from 'hooks/useBrowserMatchVersion';
import useGetOfferFile from './hooks/useGetOfferFile';

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    marginTop: spacing(3),
  },
  table: {
    marginTop: spacing(3),
  },
  clickable: {
    cursor: 'pointer',
  },
}));

export const CompletedOffers = ({ completedOffers = [] }) => {
  const classes = useStyles();
  const [browserMatch] = useBrowserMatchVersion(
    ['safari', 'mobile safari'],
    ['<13', '<13'],
  );
  const [state, setState] = useState({
    viewerOpen: false,
    downloaderOpen: false,
    offerId: null,
  });
  const modify = data => setState(old => ({ ...old, ...data }));

  const toggleViewer = ({ offerId }) =>
    modify({
      viewerOpen: true,
      offerId,
    });

  const toggleDownloader = ({ offerId }) =>
    modify({ downloaderOpen: true, offerId });

  const onClose = () =>
    modify({ viewerOpen: false, downloaderOpen: false, offerId: null });

  const date = field => offer =>
    moment(offer[field], 'YYYY-MM-DD HH:mm:ss').format('MM-DD-YYYY');

  const columns = [
    { field: 'filename', label: 'File Name' },
    {
      field: 'approvedAt',
      label: 'Date Uploaded',
      value: date('approvedAt'),
    },
    {
      field: 'actions',
      label: ' ',
      sortable: false,
      headerProps: { style: { minWidth: 100 } },
      value: ({ id: offerId }) => (
        <Grid
          container
          spacing={3}
          alignItems="center"
          justify="flex-end"
          id={`Actions-offer-${offerId}`}
        >
          {!browserMatch && (
            <Grid item>
              <EyeIcon
                id={`View-offer-${offerId}`}
                title="View Offer"
                className={classes.clickable}
                onClick={() => toggleViewer({ offerId: parseInt(offerId, 0) })}
              />
            </Grid>
          )}
          <Grid item>
            <DownloadIcon
              id={`Download-offer-${offerId}`}
              title="Download Offer"
              className={classes.clickable}
              onClick={() =>
                toggleDownloader({ offerId: parseInt(offerId, 0) })
              }
            />
          </Grid>
        </Grid>
      ),
    },
  ];

  const { viewerOpen, downloaderOpen, offerId } = state;

  return (
    <>
      <Typography variant="h3" className={classes.title}>
        Completed Offers
      </Typography>
      <Typography variant="body2">
        View your Start+ completed offer packets.
      </Typography>

      {completedOffers.length === 0 ? (
        <EmptyMyFiles
          blurb="You have no offers yet"
          blurbLine2="When you do, they'll appear here."
        />
      ) : (
        <>
          <DataTable
            id="OffersTable"
            transparent
            columns={columns}
            data={completedOffers}
            sort="approvedAt"
            order="desc"
            emptyRows="There are no offers to display."
            className={classes.table}
          />
          {viewerOpen && (
            <FileViewer
              fileFetcher={useGetOfferFile}
              config={{ offerId, isPreview: true }}
              onClose={onClose}
            />
          )}
          {downloaderOpen && (
            <FileDownloader
              urlFetcher={useGetOfferFile}
              config={{ offerId }}
              onClose={onClose}
            />
          )}
        </>
      )}
    </>
  );
};

export default CompletedOffers;
